import React from 'react'

import { Space, Table } from 'antd'
import { camelCaseToWords } from '../displayFormatters'
import { renderContent } from './previewModel'

export default function Preview({ rowKey, dataSource, attributes }) {
  if (!rowKey || rowKey === 'both') {
    rowKey = 'name'
  }

  let columns = []
  if (attributes && Array.isArray(attributes)) {
    columns = attributes.map((attribute, index) => {
      return {
        title: camelCaseToWords(attribute),
        dataIndex: attribute,
        key: attribute,
        render: renderContent(attribute, index === 0),
      }
    })
  }

  return <>
    <Space direction='vertical' style={{ width: '100%' }}>
      These are all the items that will be imported/updated. Please review and confirm the import.
      <Table
        dataSource={dataSource}
        columns={columns}
        rowKey={rowKey}
        size='small'
      />
    </Space>
  </>
}
